import DAO from './DAO.js';
import announcementsService from '../services/announcementsService';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';
import dataModel from '../models/DataModel';
import { RecordStates } from '../constants/ReduxConstants.js';

export const announcement_root = {
  announcement:
  {
  },
};

export default class AnnouncementsDAO extends DAO {

  constructor(store) {
    super(store, 'announcement');
    this.unsetAnnouncement = this.unsetAnnouncement.bind(this);
    this.clearAnnouncements = this.clearAnnouncements.bind(this);
    this.markRead = this.markRead.bind(this);
  }

  unsetAnnouncement(id) {
    StoreItemProcessing.deleteItemInStore(this.itemType, id);
  }

  clearAnnouncements() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  getAnnouncement(announcementId, options) {
    if (!options) {
      options = { recordDescriptor: { announcement: {} } };
    }
    return this._getItem(announcementId, announcementsService.getAnnouncement.bind(this, announcementId, dataModel.companiesDAO.currentCompany.id, options), options);
  }

  handleResponse(announcement, response, dontQueue, options, errorMessage) {
    if (response.offline && dontQueue) {
      return response;    
    }
    else if (response.offline) {
      this.throwItemError();
    }
    else if (response.error) {
      dataModel.displayHTTPError(errorMessage, response.error, false);
      this.markError(announcement);
      this.throwItemError();
    }
    else {
      this.normalizeAndSyncToStore(response, options);
      const denormalized = this.mapToReturn(this.findItem(response.data.id), options);
      return denormalized;
    }
  }

  async markRead(announcement, options) {
    announcementsService.markAnnouncementRead(announcement.id, null, options).then(response => {
      return this.handleResponse(announcement, response, false, options, 'Marking announcement read');
    });
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_announcements, options.toIgnore.announcements, this.unsetAnnouncement, this.clearAnnouncements, options);
  }

  checkAnnouncementsCollection(id) {
    let collectionIds = dataModel.collectionsDAO.getCollectionsByType('ANNOUNCEMENT');
    for (let collectionId of collectionIds) {
      let collection = dataModel.collectionsDAO.findCollection(collectionId);  

      if (collection && !collection.ids.find(collectionId => {return collectionId == id;})){
        collection._recordState = RecordStates.NEEDS_SYNC;
        dataModel.collectionsDAO.setCollection(collectionId, collection, 'ANNOUNCEMENT');
      }
    }
  }

  handleActionCableAndGetRequest(acData) {
    let announcement = this.findItem(acData.announcement_id);
    if (announcement) {
      if (acData.is_attribute_update) {
        this.markNeedsAttributeSync(announcement);
      }
      else {
        this.markNeedsSync(announcement);
      }
    }
    this.checkAnnouncementsCollection(acData.announcement_id);
    let options = {};
    switch (acData.type) {
    case 'newAnnouncement':
    case 'updateAnnouncement':
      return this.getAnnouncement.bind(this, acData.announcement_id, options);
    case 'deleteAnnouncement':
      this.unsetAnnouncement(acData.announcement_id);
      return announcement;
    default:
    }

  }
}



// WEBPACK FOOTER //
// ./src/dao/AnnouncementsDAO.js